import * as Yup from 'yup';


const RecordSchema = Yup.object().shape({
    over50:Yup.bool(),
    grossPay: Yup.number()
        .min(2, 'Too Short!')
        .max(150, 'Too Long!')
        .required('Required'),
    contributionPercentage: Yup.number()
        .required('Required'),
});

export default RecordSchema;
